// Import model
import { FilterProjectAppointmentRequest } from '../models/FilterProjectAppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ProjectAppointmentCondition } from '../models/ProjectAppointmentCondition';
import { ProjectAppointmentFields } from '../models/ProjectAppointmentFields';
import { ProjectAppointmentIndexedFields } from '../models/ProjectAppointmentIndexedFields';

// Import dependency serializers (for complex types)
import { ProjectAppointmentConditionSerializer } from './ProjectAppointmentConditionSerializer';
import { ProjectAppointmentFieldsSerializer } from './ProjectAppointmentFieldsSerializer';
import { ProjectAppointmentIndexedFieldsSerializer } from './ProjectAppointmentIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterProjectAppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterProjectAppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterProjectAppointmentRequest instance
   */
  static deserialize(json: string): FilterProjectAppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterProjectAppointmentRequest instance
   */
  static fromObject(obj: any): FilterProjectAppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterProjectAppointmentRequest');
    }


    const instance: FilterProjectAppointmentRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ProjectAppointmentIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ProjectAppointmentFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ProjectAppointmentConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterProjectAppointmentRequest instances
   */
  static deserializeArray(json: string): FilterProjectAppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterProjectAppointmentRequest instance to a JSON string
   */
  static serialize(instance: FilterProjectAppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterProjectAppointmentRequest instance to a plain object
   */
  static toObject(instance: FilterProjectAppointmentRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ProjectAppointmentConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterProjectAppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: FilterProjectAppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
